import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './i18n';
import './global.css';
import App from './App';
import { LayoutSkeleton } from './layout/LayoutSkeleton';
import { AuthProvider } from './shared/utils/auth/AuthContext';

const container = document.getElementById('app');
const root = createRoot(container!);

root.render(
  <React.StrictMode>
    <Suspense fallback={<LayoutSkeleton size="s" />}>
        <App />
    </Suspense>
  </React.StrictMode>
);
